import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { PRESUPUESTOS_MAIN } from 'constants/codigosTransacciones'

import MainPage from './main'

export default function PresupuestosPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${PRESUPUESTOS_MAIN}`} component={MainPage} />
      </Switch>
    </Suspense>
  )
}
